const locales = [
  {
    code: 'ca-ES',
    name: 'Català'
  },
  {
    code: 'ca-AD',
    name: 'Català (Andorra)'
  },
  {
    code: 'es-ES',
    name: 'Español (España)'
  },
  {
    code: 'es-AR',
    name: 'Español (Argentina)'
  },
  {
    code: 'es-CL',
    name: 'Español (Chile)'
  },
  {
    code: 'es-CO',
    name: 'Español (Colombia)'
  },
  {
    code: 'es-MX',
    name: 'Español (México)'
  },
  {
    code: 'en-US',
    name: 'English'
  },
  {
    code: 'eu-ES',
    name: 'Euskara'
  },
  {
    code: 'fr-FR',
    name: 'Français'
  },
  {
    code: 'it-IT',
    name: 'Italiano'
  }
]

const codes = locales.map(item => item.code)

const parseLocale = someString => {
  const normalized = someString.toLowerCase().replace('_', '-')
  let locale = locales.filter(item => item.code.toLowerCase().startsWith(normalized))
  if (locale.length === 0 && normalized.length >= 2) {
      locale = locales.filter(item => item.code.toLowerCase().startsWith(normalized.slice(0, 2)))
  }
  if (locale.length === 0) {
    return {
      code: 'en-US',
      name: 'English'
    }
  } else {
    return locale[0]
  }
}

let locale = 'en-US'
if (navigator !== 'undefined') {
  locale = navigator.userLanguage ||
    navigator.language ||
    navigator.browserLanguage ||
    navigator.systemLanguage ||
    locale
  locale = parseLocale(locale).code
}

const defaultLocale = {
  code: locale
}

export default {
  locales,
  codes,
  parseLocale,
  defaultLocale
}



// WEBPACK FOOTER //
// ./src/locales/index.js